// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NewsInteractionBar-cls1__cd5c48fcf9118575d546{/*!*/}.NewsInteractionBar-cls2___b79e62ea9336a175856{line-height:32px;min-width:33px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "NewsInteractionBar-cls1__cd5c48fcf9118575d546",
	"cls2": "NewsInteractionBar-cls2___b79e62ea9336a175856 NewsInteractionBar-cls1__cd5c48fcf9118575d546"
};
export default ___CSS_LOADER_EXPORT___;
